<template>
  <div id="datainfo-box">
    <Drawer :closable="true" width="100%" v-model="modal.visible">
      <div slot="close"><Icon type="ios-close-circle" style="margin-top: 10px;margin-right: 30px;font-size: 2.5rem;color: white"/></div>
      <div slot="header" class="header">
        <Row class="headerRow">
          <Col span="3"><label class="prefixTitle">姓名：</label>{{ edit.name }}</Col>
          <Col span="2"><label class="prefixTitle">性别：</label>{{edit.gender === 1 ? '男' : (this.edit.gender === 2 ? '女' : '')}}</Col>
          <Col span="3"><label class="prefixTitle">年龄：</label>{{edit.age}}</Col>
          <Col span="4"><label class="prefixTitle">出生日期：</label>{{edit.birthday}}</Col>
          <Col span="6"><label class="prefixTitle">证件号码：</label>{{edit.idCard}}</Col>
          <Col span="4">
            <label class="prefixTitle">检查状态：</label>
            <el-tag size="small" v-if="edit.physicalCheckStatus">
              <span v-if="edit.physicalCheckStatus===1" style="color:#FF5252;font-size: 16px;">未检 <span v-if="edit.globalCheckStatus===2">(请假)</span></span>
              <span v-else-if="edit.physicalCheckStatus===2" style="color: #FF9800A3;font-size: 16px;">部分已检 <span v-if="edit.globalCheckStatus===2">(请假)</span></span>
              <span v-else-if="edit.physicalCheckStatus===3" style="color: #4CAF50;font-size: 16px;">已完成</span>
            </el-tag>
          </Col>
        </Row>

        <Row class="headerRow">
          <Col span="3">
            <label class="prefixTitle">状态：</label>
            <el-tag size="small" v-if="edit.status"><span :style="{'color':(edit.status === 1?'#4CAF50':'#FF5252'),'font-size':'16px'}">{{edit.status === 1 ? '启用' : edit.status === 2 ? '停用' : ''}}</span></el-tag>
          </Col>
          <Col span="5"><label class="prefixTitle">学校：</label>{{edit.schoolName}}</Col>
          <Col span="4"><label class="prefixTitle">年级：</label>{{ edit.gradeName }}</Col>
          <Col span="6"><label class="prefixTitle">班级：</label>{{edit.className}}</Col>
          <Col span="4"><label class="prefixTitle">条形码：</label>{{edit.barCode}}</Col>
        </Row>
        <Row class="headerRow">
          <Col><label class="prefixTitle">地址：</label>{{edit.address}}</Col>
        </Row>
      </div>

      <Row>
        <Col :span="openLeftPackage?4:1">
          <el-card class="box-card left-card" :style="{'height':maxHeight,'margin-right':'10px'}">
            <div slot="header" class="clearfix">
              <span style="font-size: 16px;float: left;" v-if="openLeftPackage">列表</span>
              <div :style="{'display':'flex','justify-content': (openLeftPackage?'right':'center')}">
                <Button style="font-size: 15px;" type="primary" size="small" v-if="openLeftPackage" @click="query()">查询</Button>
                <i :class="openLeftPackage?'el-icon-s-fold':'el-icon-s-unfold'" style="font-size:28px" @click="handleOpenLeft()"/>
              </div>
            </div>

            <Form class="left-card-form" :label-width="70" :model="search" id="searchForm" v-if="openLeftPackage">
              <Row><Col><FormItem label="条形码"><el-input v-model="search.barCode" clearable placeholder="请输入检查号" :clearable="true" :maxlength="13" @input="toInt()" style="width: 100%;"/></FormItem></Col></Row>
              <Row><Col><FormItem label="姓名"><el-input v-model="search.name" clearable placeholder="请输入姓名" :clearable="true" maxlength="50" style="width: 100%;"/></FormItem></Col></Row>
              <Row><Col><FormItem label="证件号码"><el-input v-model="search.idCard" clearable placeholder="请输入身份证" :clearable="true" maxlength="18" style="width: 100%;"/></FormItem></Col> </Row>
              <Row>
                <Col>
                  <FormItem label="体检任务"  prop="taskId">
                    <el-select v-model.trim="search.taskId" placeholder="体检任务"  @change="changeTask"
                               clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="width: 100%;">
                      <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" show-overflow-tooltip style="width: 100%;"/>
                    </el-select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem  label="学校名称"  prop="schoolId">
                    <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                               clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                               style="width: 100%;" @change="changeSchool">
                      <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item.value" show-overflow-tooltip style="width: 100%;"/>
                    </el-select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <FormItem  label="年级"  prop="gradeId" :label-width="40" >
                    <el-select v-model.trim="search.gradeId" placeholder="年级"
                               clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                               style="width: 100%;" @change="changeGrade">
                      <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" show-overflow-tooltip style="width: 100%;"/>
                    </el-select>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem  label="班级"  prop="classesId" :label-width="40" >
                    <el-select v-model.trim="search.classesId" placeholder="班级" @change="changeClasses"
                               clearable filterable size="small" transfer="true"
                               style="width: 100%;" :popper-append-to-body="false">
                      <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id" show-overflow-tooltip style="width: 100%;"/>
                    </el-select>
                  </FormItem>
                </Col>
              </Row>
            </Form>

            <el-table ref="table" class="left-card-table" :data="dataList" highlight-selection-row :max-height="tableMaxHeight" :row-class-name="tableDataRowClassName"
                      @row-click="handleDataRowClick" :header-cell-style="{background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
                      :row-style="{'text-align':'center', 'font-size': '12px;'}" v-if="openLeftPackage">
              <el-table-column label="条形码" prop="barCode" width="125" align="center"/>
              <el-table-column label="姓名" prop="name" align="center" min-width="70"/>
              <el-table-column align="center" prop="globalCheckStatus" label="状态" min-width="95">
                <template slot-scope="{row}">
                  <el-tag size="small" :type="row.globalCheckStatus===1?'danger':row.globalCheckStatus===2?'danger':row.globalCheckStatus===3?'warning':'primary'" disable-transitions>
                    {{ enums.globalCheckStatus.filter(u => u.value === row.globalCheckStatus)[0].label }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </Col>
        <Col :span="2">
          <el-card class="box-card" :style="{'height':maxLeftHeight,'margin-right':'10px'}">
            <el-table class="date-table" ref="table" :data="datesList" highlight-current-row highlight-selection-row :show-header="false"
                      :max-height="maxLeftHeight" :row-class-name="tableRowClassName" @row-click="handleRowClick"
                      :border="false" :header-cell-style="{ 'text-align': 'center'}">
              <el-table-column fixed prop="physicalDate" align="center" max-width="100"/>
            </el-table>
          </el-card>
        </Col>
        <Col :span="openLeftPackage?18:21">
          <Tabs :value="activeTab" @on-click="changeTab" type="card">
            <TabPane label="体检表" name="physical" v-loading="loading" element-loading-text="拼命加载中">
              <Row>
                <Col span="24">
                  <div class="btn_group" v-if="edit.barCode">
                    <Button type="primary" @click="save">保存</Button>
                    <Button type="primary" @click="printBarCode">条形码</Button>
                    <Button type="primary" @click="evaluate">健康评价</Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <ScreeningFormList v-if="queryProjectsData && queryProjectsData.length > 0" ref="screeningFormList" :physicalId="physicalId" :barCode="barCode"
                                     :queryProjectsData.sync="queryProjectsData" :style="{'max-height':maxRightHeight,'overflow-y':'auto','box-sizing':'border-box'}" @on-success="handleSuccess"/>
                </Col>
              </Row>
            </TabPane>
            <TabPane label="体检报告" name="report">
              <Row>
                <Col span="24">
                  <div class="btn_group" v-if="edit.barCode">
                    <Button type="primary" @click="printReport" v-if="reportTypes && reportTypes.length > 0">打印</Button>
                    <el-popover placement="top" width="260" v-model="publishVisible">
                      <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 60px; font-size: 16px; ">
                        <i class="el-popconfirm__icon el-icon-info" style="color: #409EFF;"/>确定发布体检报告到小程序？
                      </p>
                      <div style="text-align: right; margin: 0;line-height: 30px;">
                        <el-button size="small" type="text" @click="publishVisible = false" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
                        <el-button type="primary" size="small" @click="publish">确定</el-button>
                      </div>
                      <template #reference><Button type="primary">发布</Button></template>
                    </el-popover>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <ScreeningReport ref="screeningReport" v-if="reportTypes && reportTypes.length > 0" :physicalId="physicalId" :barCode="barCode" :report-types="reportTypes"
                                   @onSetReportData="setReportData" :conrrentReport.sync="conrrentReport" :style="{'box-sizing':'border-box'}"/>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </Drawer>

    <a id="toPrintReport" v-print="printReportContent" v-show="false">打印</a>
  </div>
</template>
<script>
import  ScreeningFormList from "./ScreeningFormList.vue"
import ScreeningReport from "./ScreeningReport.vue"
import {_page, _getResidentInfo, _getPhysicalData,_getPhysicalForm,_getPhysicalReportType, _batchEvaluate, _publish} from "@/services/screening/screeningDatainfo";
import {_classesList, _gradesList} from "@/services/studentManage/studentManage";
import {enums} from "@/services/enums";
import Long from "@zxing/library/es2015/core/util/Long";

export default {
  name: "ScreeningDataInfoEdit",
  components: {ScreeningFormList,ScreeningReport,},
  props: {
    taskList: {
      type: Array,
      default: () => {
        return []
      }
    },
    schoolList: {
      type: Array,
      default: () => {
        return []
      }
    },
    taskId: {
      type: Long,
      default: () => {
        return null
      }
    },
    schoolId: {
      type: Long,
      default: () => {
        return null
      }
    },
    gradeId: {
      type: Long,
      default: () => {
        return null
      }
    },
    classesId: {
      type: Long,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      maxLeftHeight: 0,
      maxRightHeight: 0,
      physicalId:'',
      barCode: -1,
      physicalDate: '',
      conrrentReport: '',
      currentDataRowIndex: 0,
      currentRowIndex: 0,
      activeTab:'physical',
      openLeftPackage:true,
      maxHeight: window.innerHeight - 275,
      tableMaxHeight: window.innerHeight - 275,
      rightHeight: window.innerHeight - 275,
      enums: enums,
      loading: false,
      search:{
        name: "",
        idCard: "",
        taskId: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        barCode: "",
        globalCheckStatus: "",
        optionsStatus: "",
        lisCheckStatus: "",
        publishStatus: "",
        collectionStatus: "",
        status: 1,
      },
      modal: {
        visible: false
      },
      gradeList: [],
      classesList: [],
      dataList:[],
      datesList:[],
      pageList: {
        currentPage: 1,
        pageSize: 3000,
        total: 0
      },
      menuLabels:[
        {name: '体检表', code: '1-1', tab: 'physical'},
        {name: '体检报告', code: '1-2', tab: 'report'}
      ],
      publishVisible:true,
      edit: {},
      queryProjectsData:[],
      reportTypes:[],
      reportData: {},
      printReportContent: {
        id: "print_report",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language" content="zh-cn"/>',
        previewBeforeOpenCallback(vue){},
        previewOpenCallback(vue){},
        beforeOpenCallback(vue){},
        openCallback(vue){},
        closeCallback(){},
        clickMounted(vue){}
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    window.addEventListener('resize', this.setDynamicHeight);
  },
  watch:{
    'search.barCode': {
      handler(newVal) {
        if(newVal&&(newVal.length==13)){
          this.handleDataList();
        }else if(!newVal){
          this.handleDataList();
        }
      }
    },
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.maxLeftHeight = `${height - 100}px`;
      this.maxRightHeight = `${height - 190}px`;

      this.maxHeight = `${height - 100}px`;
      this.tableMaxHeight = `${height - 400}px`;
      this.rightHeight = `${height - 170}px`;
    },
    handleOpenLeft(){
      this.openLeftPackage = !this.openLeftPackage;
      this.$forceUpdate();
    },
    tableDataRowClassName(row) {
      row.row.index = row.rowIndex;
      if (this.currentDataRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    async handleDataRowClick(e, index, event){
      this.currentDataRowIndex = e.index;
      this.physicalId = e.physicalId;
      this.barCode = e.barCode;
      this.physicalDate = e.physicalDate;
      await this.applyResidentInfo(e.physicalId, e.physicalDate);
      await this.applyPhysicalForm(e.physicalId);
      this.applyReportTypes(e.barCode);
    },
    tableRowClassName(row) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    handleRowClick(e, index, event){
      this.currentRowIndex = e.index;
      this.physicalId = e.physicalId;
      this.barCode = e.barCode;
      this.applyResidentInfo(e.physicalId, e.physicalDate);
      this.applyPhysicalForm(e.physicalId);
      this.applyReportTypes(e.barCode);
    },
    changeTab(val){
      this.activeTab = val;
      if(val === 'physical'){
        this.applyPhysicalForm(this.physicalId, this.physicalDate);
      }else{
        this.applyReportTypes(this.barCode);
      }
    },
    handleShow(row){
      this.activeTab = 'physical';
      this.search = {
        name: "",
        idCard: "",
        taskId: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        barCode: "",
        globalCheckStatus: "",
        optionsStatus: "",
        lisCheckStatus: "",
        publishStatus: "",
        collectionStatus: "",
        status: 1,
      };
      this.dataList = [];
      this.datesList = [];
      this.edit = {};
      this.queryProjectsData = [];
      this.reportTypes = [];
      this.reportData = {};

      if(row){
        this.dataList.push(row)

        this.physicalId = row.physicalId;
        this.barCode = row.barCode;
        this.currentRowIndex = 0;

        //个人信息
        this.applyResidentInfo(row.physicalId, row.physicalDate);
        //列表历史数据
        // this.applyPhysicalDate(row.physicalId);
        //体检表单 数据
        this.applyPhysicalForm(row.physicalId);
        //报告标签名称
        this.applyReportTypes(row.barCode);
      }else{
        this.search.taskId = this.taskId;
        this.search.schoolId = this.schoolId;
        this.search.gradeId = this.gradeId;
        this.search.classesId = this.classesId;
        if(this.search.taskId || this.search.schoolId || this.search.gradeId || this.search.classesId){
          this.handleDataList();
        }
        this.modal.visible=true
      }
    },
    applyResidentInfo(physicalId, physicalDate){
      this.edit = {};
      _getResidentInfo({physicalId: physicalId}).then(res => {
          if (res.errcode === 1){
            this.edit = Object.assign({}, res.data);
            if(physicalDate){
              for (let index = 0; index < res.data.physicalDates.length; index++) {
                  if(res.data.physicalDates[index].physicalDate && res.data.physicalDates[index].physicalDate == physicalDate){
                    this.currentRowIndex = index;
                  }
              }
            }
            this.datesList = res.data.physicalDates;
            this.modal.visible=true
            this.$forceUpdate();
          }
      }).catch(e=>{

      }).finally(() => {

      })
    },
    applyPhysicalDate(physicalId) {
      this.datesList = [];
      _getPhysicalData({physicalId: physicalId}).then(res=>{
        if (res.errcode === 1){
          this.datesList = Object.assign([], res.data);
        }
      }).catch(e=>{

      }).finally(() => {

      })
    },
    applyPhysicalForm(physicalId){
      this.loading = true;
      this.queryProjectsData = [];
      _getPhysicalForm({physicalId: physicalId}).then(res=>{
        this.loading = false;
        if (res.errcode === 1){
          this.queryProjectsData = res.data;
        }
      }).catch(e=>{
        this.loading = false;
      }).finally(() => {
        // this.loading = false;
      })
    },
    applyReportTypes(barCode){
      this.reportTypes = [];
      this.conrrentReport = "";
      _getPhysicalReportType({barCode: barCode}).then(res=>{
        if (res.errcode === 1){
          this.reportTypes = res.data;
        }
      }).catch(e=>{

      }).finally(() => {

      })
    },
    changeTask(taskId){
      this.search.taskId = taskId;
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    changeSchool(schoolId) {
      if (!schoolId) {
        this.gradeList = [];
        this.classesList = [];
        this.search.gradeId = "";
        this.search.classesId = "";
        return;
      }
      _gradesList({schoolId: schoolId}).then(res => {
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.gradeList = res.data;
        } else {
          this.gradeList = []
        }

        this.pageList.currentPage = 1;
        this.handleDataList();
      })
    },
    changeGrade(gradeId) {
      if (!gradeId) {
        this.classesList = [];
        this.search.classesId = "";
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId: gradeId}).then(res => {
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.classesList = res.data;
        } else {
          this.classesList = []
        }

        this.pageList.currentPage = 1;
        this.handleDataList();
      })
    },
    changeClasses(classesId){
      this.search.classesId = classesId;
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    query() {
      if(!this.search.name&&!this.search.idCard&&!this.search.taskId&&!this.search.schoolId
        &&!this.search.gradeId&&!this.search.classesId&&!this.search.barCode){
        this.$message.warning('条件不能为空');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      if(!this.search.name&&!this.search.idCard&&!this.search.taskId&&!this.search.schoolId
        &&!this.search.gradeId&&!this.search.classesId&&!this.search.barCode){
        this.dataList = [];
        this.datesList = [];
        this.edit = {};
        this.queryProjectsData = [];
        this.reportTypes = [];
        this.reportData = {};
        return;
      }

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    save(){
      this.$refs['screeningFormList'].handleSubmit();
    },
    printBarCode() {
      this.$emit('on-barCode', {physicalId:this.physicalId, barCode:this.barCode}, true)
    },
    evaluate(){
      _batchEvaluate({barCode: this.barCode}).then(res=>{
        if (res.errcode === 1){
          this.$message.success("评价成功");
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(e=>{
      })
    },
    printReport(){
      if(!this.conrrentReport){
        this.$message.warning("没有报告");
        return;
      }
      this.printReportContent.id = "print_" + this.conrrentReport;

      this.$refs.screeningReport.printData = this.reportData;
      this.$nextTick(()=>{
        setTimeout(() => {
          document.getElementById('toPrintReport').click();
        }, 1000);
      })
    },
    setReportData(reportData){
      this.reportData = reportData;
    },
    publish() {
      this.publishVisible = false;
      _publish({physicalId: this.physicalId}).then(res => {
        if (res.errcode === 1) {
          this.$message.success('发布成功');
          this.handleDataList();
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    handleSuccess(){
      this.handleDataList();
      this.applyResidentInfo(this.physicalId);
      this.applyPhysicalForm(this.physicalId);
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .ivu-drawer-content {width: 100%;height: 100%;position: absolute;top: 0;bottom: 0;background-color: #f0f0f0;border: 0;background-clip: padding-box;-webkit-box-shadow: 0 4px 12px rgb(0 0 0 / 15%);box-shadow: 0 4px 12px rgb(0 0 0 / 15%);}
/deep/ .el-card__header {padding: 10px 10px;border-bottom: 0px solid #EBEEF5;}
/deep/ .el-card__body, .el-main {padding: 5px;}
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .ivu-drawer-header {border-bottom: 1px solid #e8eaec;padding: 0px 0px;line-height: 1;}
/deep/ .ivu-drawer-body{padding-left: 5px;padding-right: 15px;padding-top: 5px;}
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
.header{background-color: rgba(17, 114, 217, 0.88);color: white;font-size: 15px;border-top-left-radius: 10px;border-top-right-radius: 10px;padding-top: 5px;padding-bottom: 5px;}
.headerRow{line-height: 25px;}
.prefixTitle{margin-left: 10px;font-weight: normal;}
.btn_group{display: flex;justify-content: flex-start;margin-bottom: 10px;}

/deep/ .left-card-form .ivu-form-item {margin-bottom: 2px;vertical-align: top;zoom: 1;}
/deep/ .left-card .el-card__header {padding: 10px 10px;border-bottom: 1px solid #EBEEF5;}
/deep/ .el-table .el-table__cell {padding: 6px 0;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
.btn_group button{margin-left: 5px;}

/deep/ .date-table .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .date-table .el-table thead {color: #515a6e;font-weight: 500;}
/deep/ .date-table .el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell {background-color: #beffc5;}
/deep/ .date-table .el-table .current-row td{background: #beffc5;color: #101010;}
/deep/ .date-table .ivu-table .current-row td{background: #beffc5;color: #101010;}
/* 移除外层包裹的伪元素边框 */
/deep/ .date-table .el-table::before {height: 0 !important;  /* 底部外边框 */}
/deep/ .date-table .el-table__fixed::before,
/deep/ .date-table .el-table__fixed-right::before {width: 0 !important;  /* 移除固定列左侧分隔线 */}
/* 清除带有 border 属性的表格边框 */
/deep/ .date-table .el-table--border,
/deep/ .date-table .el-table--group {border: none !important;  /* 完全移除外框线 */}
/deep/ .date-table .el-table td.el-table__cell,
/deep/ .date-table .el-table th.el-table__cell {border: none !important;  /* 移除单元格所有边框 */}

</style>
